<template>
  <b-overlay
      :show="overlay"
      rounded="sm"
  >
    <b-row>
      <b-col cols="12">
        <b-card class="">
          <h4 class="text-primary">
            <feather-icon icon="PlusSquareIcon" size="20"/>
            افزودن کارت بانکی
          </h4>

          <b-row>
            <b-media class="my-2 col-12">
              <validation-observer
                  ref="refFormObserver"
              >
                <b-row>
                  <b-col cols="12" md="4">
                    <b-form-group
                        label="نام حساب"
                        label-for="blog-content"
                        class="mb-2"
                    >
                      <validation-provider
                          #default="{ errors }"
                          rules="required"
                      >
                        <b-form-input
                            id="blog-content"
                            rows="4"
                            v-model="newBankCard.accountName"
                            :state="errors.length > 0 ? false:null"
                        ></b-form-input>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" md="4">
                    <b-form-group
                        label="نام بانک"
                        label-for="blog-content"
                        class="mb-2"
                    >
                      <validation-provider
                          #default="{ errors }"
                          rules="required"
                      >
                        <b-form-input
                            id="blog-content"
                            rows="4"
                            v-model="newBankCard.bankName"
                            :state="errors.length > 0 ? false:null"
                        ></b-form-input>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" md="4">
                    <b-form-group
                        label="شماره کارت بانکی"
                        label-for="blog-content"
                        class="mb-2"
                    >
                      <validation-provider
                          #default="{ errors }"
                          rules="required"
                      >
                        <b-form-input
                            dir="auto"
                            id="blog-content"
                            rows="4"
                            v-model="newBankCard.cardNumber"
                            :state="errors.length > 0 ? false:null"
                        ></b-form-input>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" md="4">
                    <template>
                      <p class="mb-1">لوگو بانک</p>
                      <b-avatar
                          class="cursor-pointer w-100"
                          ref="previewEl"
                          :src="base64ImageSrc"
                          size="300px"
                          rounded
                          @click.native="$refs.refInputEl.click()"
                      >
                        <feather-icon v-if="base64ImageSrc === null" icon="PlusSquareIcon" size="100"/>
                      </b-avatar>
                    </template>
                    <b-button
                        variant="warning"
                        @click="$refs.refInputEl.click()"
                        class="mt-2 mb-sm-0 mr-2 col-12 col-md-5 d-none"
                    >
                      <input
                          ref="refInputEl"
                          type="file"
                          accept=".jpg,.jpeg,.png"
                          class="d-none"
                          @input="makeBase64Pic"
                      >
                    </b-button>
                  </b-col>
                  <b-col cols="12">
                    <b-button
                        variant="primary"
                        class="mt-2 mb-sm-0 mr-0"
                        :block="$store.getters['app/currentBreakPoint'] === 'xs'"
                        @click="setData"
                    >
                      ثبت
                    </b-button>
                  </b-col>
                </b-row>
              </validation-observer>
            </b-media>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <b-row v-if="pageData.length > 0">
      <b-col cols="12">
        <b-card no-body>
          <h4 class="m-2 ">لیست کارت‌های بانکی</h4>

          <b-table
              ref="refUserListTable"
              class="position-relative"
              :items="pageData"
              responsive
              :sort-by.sync="sortBy"
              :fields="myTableColumns"
              primary-key="id"
              show-empty
              bordered
              striped
              empty-text="موردی موجود نیست!"
          >

            <template #cell(bankName)="data">
              <a target="_blank">
                <b-avatar size="100" square :src="baseUrl+'media/gallery/banklogo/'+data.item.bankLogo"/>
                <span class=" ml-2">{{ data.item.bankName }}</span>
              </a>
            </template>

            <template #cell(isDefault)="data">
              <span class="text-success" v-if="data.item.isDefault">کارت پیشفرض</span>
              <span v-else>-</span>
            </template>

            <template #cell(setDefault)="data">
              <b-button
                  variant="primary"
                  class="mt-2 mb-sm-0 mr-0"
                  :block="$store.getters['app/currentBreakPoint'] === 'xs'"
                  @click="setDefaultCard(data.item.id)"
              >
                انتخاب کارت
              </b-button>
            </template>

            <template #cell(operation)="data">
              <div class="d-flex align-items-center justify-content-start">

                <div v-b-modal.modal-edit @click="setDataToUpdate(JSON.parse(JSON.stringify(data.item)))">
                  <feather-icon class="text-primary" icon="EditIcon" size="20"/>
                </div>

                <div class="cursor-pointer d-flex flex-row mx-1"
                     v-b-modal.modal-delete
                     @click="selectedToDelete = JSON.parse(JSON.stringify(data.item))"
                >
                  <feather-icon icon="TrashIcon" size="20" class="text-danger"/>
                </div>
              </div>
            </template>
          </b-table>
          <div class="mx-2 mb-2">
            <b-row>
              <!-- Pagination -->
              <b-col
                  cols="12"
                  sm="12"
                  class="d-flex align-items-center justify-content-between flex-wrap flex-md-nowrap"
              >
                <b-pagination
                    v-model="currentPage"
                    :total-rows="totalCount"
                    :per-page="count"
                    first-number
                    last-number
                    class="mb-2 mb-md-0 mt-1 mt-sm-0"
                    prev-class="prev-item"
                    next-class="next-item"
                >
                  <template #prev-text>
                    <feather-icon style="transform: rotate(180deg)"
                                  icon="ChevronLeftIcon"
                                  size="18"
                    />
                  </template>
                  <template #next-text>
                    <feather-icon
                        icon="ChevronRightIcon"
                        size="18"
                    />
                  </template>
                </b-pagination>

                <b-col
                    cols="12"
                    md="2"
                    class="d-flex align-items-center justify-content-start justify-content-md-end mb-2 mb-md-0"
                >
                  <label>نمایش</label>
                  <v-select
                      v-model="count"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="perPageOptions"
                      :clearable="false"
                      class="per-page-selector d-inline-block mx-50 w-50"
                  />
                  <label>تعداد</label>
                </b-col>
              </b-col>
            </b-row>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <b-modal
        id="modal-edit"
        centered
        ok-title="ویرایش"
        cancelTitle="انصراف"
        @ok="updateData()"
    >
      <div class="relative">
        <b-avatar
            class="cursor-pointer w-100"
            ref="previewEl"
            :src="base64ImageSrcForUpdate"
            size="300px"
            rounded
            @click.native="clickOnInput(selectedToEdit.id)"
        >
        </b-avatar>
        <b-button
            type="button"
            variant="warning"
            @click="clickOnInput(selectedToEdit.id)"
            class="mt-2 mb-sm-0 mr-2 col-12 col-md-5 absolute bottom-0 left-0"
        >
          ویرایش لوگو
          <input
              :id="selectedToEdit.id"
              type="file"
              accept=".jpg,.jpeg,.png"
              class="d-none"
              @input="makeBase64PicForUpdate"
          >
        </b-button>
      </div>

      <b-form-group
          class="mt-2"
          label="نام حساب"
      >
        <b-form-input
            :id="selectedToEdit.id"
            v-model="selectedToEdit.accountName"
        ></b-form-input>
      </b-form-group>

      <b-form-group
          class="mt-2"
          label="نام بانک"
      >
        <b-form-input
            :id="selectedToEdit.id"
            v-model="selectedToEdit.bankName"
        ></b-form-input>
      </b-form-group>

      <b-form-group
          class="mt-2"
          label="شماره کارت"
      >
        <b-form-input
            :id="selectedToEdit.id"
            v-model="selectedToEdit.cardNumber"
        ></b-form-input>
      </b-form-group>
    </b-modal>

    <b-modal
        id="modal-delete"
        centered
        ok-title="حذف"
        cancelTitle="انصراف"
        @ok="deleteData()"
    >
      <span>حذف شود؟</span>
    </b-modal>
  </b-overlay>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BButton,
  BFormGroup,
  BFormInput,
  BMedia,
  BAvatar,
  BOverlay, BModal,BTable , BPagination
} from 'bootstrap-vue'
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import {MediaCreateFileRequest} from "@/libs/Api/Media";
import {ValidationObserver, ValidationProvider} from "vee-validate";
import Helper from "@/libs/Helper";
import {BlogCreateBlogRequest} from "@/libs/Api/Blog";
import {required} from '@validations';
import {
  BankCardCreateOrUpdateRequest,
  BankCardDeleteRequest,
  BankCardGetListRequest,
  BankCardSetDefaultCardRequest
} from "@/libs/Api/BankCard";

export default {
  title: 'کارت‌های بانکی‌ - پنل ادمین اکسپویاب',
  data() {
    return {
      required,
      overlay: false,
      baseUrl:Helper.baseUrl,
      pageData: [],
      base64ImageSrc: null,
      base64ImageSrcForUpdate: null,
      newBankCard: {
        id: null,
        accountName:null,
        bankName:null,
        cardNumber:null,
        base64Logo:null,
      },
      perPageOptions: [10, 20, 30, 40, 50],
      currentPage: 1,
      sortBy: '',
      count: 10,
      totalCount: null,
      selectedToDelete: null,
      selectedToEdit: {},
      myTableColumns: [
        {
          key: 'bankName',
          label: 'بانک',
        },
        {
          key: 'accountName',
          label: 'نام حساب',
        },
        {
          key: 'cardNumber',
          label: 'شماره کارت',
        },
        {
          key: 'isDefault',
          label: 'ویژگی کارت',
        },
        {
          key: 'setDefault',
          label: 'انتخاب کارت پیشفرض'
        },
        {
          key: 'operation',
          label: 'عملیات'
        },
      ],
    }
  },
  async created() {
    await this.getData();
  },
  watch: {
    currentPage: function (nv, ov) {
      this.getData();
    },
    count: function (nv, ov) {
      this.getData();
    },
  },
  methods: {
    async getData() {
      let _this = this;
      _this.overlay = true;

      let data = {
        page: _this.currentPage,
        size: _this.count,
      }

      let bankCardGetListRequest = new BankCardGetListRequest(_this);
      bankCardGetListRequest.setParams(data);
      await bankCardGetListRequest.fetch(function (content) {
        _this.overlay = false;
        _this.pageData = content.data.data;
        _this.totalCount = content.totalCount;
      }, function (error) {
        _this.overlay = false;
        console.log(error)
      })
    },
    async updateData() {
      let _this = this;
      if (_this.selectedToEdit.accountName.length < 1 || _this.selectedToEdit.bankName.length < 1 || _this.selectedToEdit.cardNumber.length < 1 ) {
        return _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            variant: 'danger',
            text: `تمامی موارد الزامی هستند.`,
          },
        })
      }
      _this.showOverlay = true;
      let bankCardCreateOrUpdateRequest = new BankCardCreateOrUpdateRequest(_this);
      bankCardCreateOrUpdateRequest.setParams(_this.selectedToEdit);
      await bankCardCreateOrUpdateRequest.fetch(function (content) {
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `عملیات موفق`,
            icon: 'CheckIcon',
            variant: 'success',
            text: `کارت بانکی ویرایش شد.`,
          },
        })
        _this.showOverlay = false;
        _this.selectedToEdit = {};
        _this.base64ImageSrcForUpdate = null;
        _this.getData();
      }, function (error) {
        _this.showOverlay = false;
        console.log(error)
      })
    },
    async setData() {
      let _this = this;

      if (_this.newBankCard.base64Logo === null){
        return _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            variant: 'danger',
            text: `تصویر کارت بانکی الزامی است.`,
          },
        })
      }

      Helper.validateForm(_this, 'refFormObserver', async () => {
        _this.showOverlay = true;

        let bankCardCreateOrUpdateRequest = new BankCardCreateOrUpdateRequest(_this);
        bankCardCreateOrUpdateRequest.setParams(_this.newBankCard);
        await bankCardCreateOrUpdateRequest.fetch(function (content) {
          _this.$toast({
            component: ToastificationContent,
            position: 'bottom-center',
            props: {
              title: `عملیات موفق`,
              icon: 'CheckIcon',
              variant: 'success',
              text: `کارت بانکی ساخته شد.`,
            },
          })
          _this.showOverlay = false;
          _this.base64ImageSrc = null;
          _this.newBankCard = {
            id: null,
            accountName:null,
            bankName:null,
            cardNumber:null,
            base64Logo:null,
          }
          _this.getData();
        }, function (error) {
          _this.showOverlay = false;
          console.log(error)
        })
      })
    },
    async deleteData(){
      let _this = this;
      _this.overlay = true;

      let bankCardDeleteRequest = new BankCardDeleteRequest(_this);
      bankCardDeleteRequest.setParams({id:_this.selectedToDelete.id});
      await bankCardDeleteRequest.fetch(function (content) {
        _this.overlay = false;
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `عملیات موفق`,
            icon: 'CheckIcon',
            variant: 'success',
            text: `حذف شد.`,
          },
        })
        _this.selectedToDelete = null;
        _this.getData();
      }, function (error) {
        _this.overlay = false;
        console.log(error)
      })
    },
    async setDefaultCard(id){
      let _this = this;
      _this.overlay = true;

      let bankCardSetDefaultCardRequest = new BankCardSetDefaultCardRequest(_this);
      bankCardSetDefaultCardRequest.setParams({id:id});
      await bankCardSetDefaultCardRequest.fetch(function (content) {
        _this.overlay = false;
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `عملیات موفق`,
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
        _this.getData();
      }, function (error) {
        _this.overlay = false;
        console.log(error)
      })
    },
    async readAsDataURL(file) {
      return new Promise((resolve, reject) => {
        const fr = new FileReader();
        fr.onerror = reject;
        fr.onload = () => {
          resolve(fr.result.split(",")[1]);
        }
        fr.readAsDataURL(file);
      });
    },
    async makeBase64Pic(e){
      const _this = this;
      let file = e.target.files[0];
      _this.base64ImageSrc = URL.createObjectURL(file)
      _this.newBankCard.base64Logo = await _this.readAsDataURL(file);
    },
    async makeBase64PicForUpdate(e){
      const _this = this;
      let file = e.target.files[0];
      _this.base64ImageSrcForUpdate = URL.createObjectURL(file);
      _this.selectedToEdit.base64Logo = await _this.readAsDataURL(file);
    },
    clickOnInput(id){
      let input = document.getElementById(id);
      input.click();
    },
    setDataToUpdate(data){
      this.base64ImageSrcForUpdate = null;
      this.selectedToEdit = data;
      this.selectedToEdit['base64Logo'] = null;
    }
  },
  components: {
    BModal,
    BCard,
    BRow,
    BCol,
    BButton,
    BFormGroup,
    BFormInput,
    BMedia,
    BAvatar,
    BOverlay,
    BTable,
    BPagination,
    vSelect,
    ToastificationContent,
    ValidationObserver, ValidationProvider,
  },
}
</script>

<style scoped>

</style>